// 立即输出，确保即使后续导入失败也能看到这个输出
// console.log('🔧 [0] main.js 文件已开始执行 - 这是第一个输出')
window.__MAIN_JS_LOADED__ = true
// console.log('🔧 [0.0] 已设置加载标记')

import Cookies from 'js-cookie'
// console.log('🔧 [0.1] Cookies 导入完成')

import { createApp } from 'vue'
// console.log('🔧 [0.2] Vue 导入完成')

import ElementPlus from 'element-plus'
// console.log('🔧 [0.3] ElementPlus 导入完成')

import 'element-plus/dist/index.css'
// console.log('🔧 [0.4] ElementPlus CSS 导入完成')

import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// console.log('🔧 [0.5] ElementPlus 语言包导入完成')

// svg图标
import 'virtual:svg-icons-register'
// console.log('🔧 [0.6] SVG图标注册完成')

import store from './store'
// console.log('🔧 [0.7] Store 导入完成')

import router from './router'
// console.log('🔧 [0.8] Router 导入完成')

import '@/assets/styles/index.scss' // global css
// console.log('🔧 [0.9] 全局样式导入完成')

import directive from './directive' // directive
// console.log('🔧 [0.10] Directive 导入完成')

// 注册指令
import plugins from './plugins' // plugins
// console.log('🔧 [0.11] Plugins 导入完成')

import SvgIcon from '@/components/SvgIcon'
// console.log('🔧 [0.12] SvgIcon 组件导入完成')

import elementIcons from '@/components/SvgIcon/svgicon'
// console.log('🔧 [0.13] ElementIcons 导入完成')

import './permission' // permission control.路由权限控制模块
// console.log('🔧 [0.14] Permission 模块导入完成')

import { fullUrl } from './utils/image'
// console.log('🔧 [0.15] Image工具导入完成')

import { useDict } from '@/utils/dict'
// console.log('🔧 [0.16] Dict工具导入完成')

import { download } from '@/utils/request'
// console.log('🔧 [0.17] Request工具导入完成')

import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/utils/ruoyi'
// console.log('🔧 [0.18] Ruoyi工具导入完成')

// 分页组件
import Pagination from '@/components/Pagination'
// console.log('🔧 [0.19] Pagination组件导入完成')

// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// console.log('🔧 [0.20] RightToolbar组件导入完成')

// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// console.log('🔧 [0.21] ImageUpload组件导入完成')

// 富文本组件,用在notice模块
import Editor from "@/components/Editor"
// console.log('🔧 [0.22] Editor组件导入完成')

// 文件上传组件,暂未任何页面实际使用
import FileUpload from "@/components/FileUpload"
// console.log('🔧 [0.23] FileUpload组件导入完成')

// 图片预览组件,该组件目前用于在司机列表里预览司机图片，src 通过 fullUrl(row.image) 转换为完整地址
import ImagePreview from "@/components/ImagePreview"
// console.log('🔧 [0.24] ImagePreview组件导入完成')

// 自定义树选择组件,暂未任何页面实际使用
import TreeSelect from '@/components/TreeSelect'
// console.log('🔧 [0.25] TreeSelect组件导入完成')

// 字典标签组件
import DictTag from '@/components/DictTag'
// console.log('🔧 [0.26] DictTag组件导入完成')

// console.log('🔧 [1] main.js 文件开始加载 - 所有导入语句已执行')

import App from './App'

// console.log('🔧 [2] 所有模块导入完成')

// PWA Service Worker注册和工具函数 - 使用动态导入避免阻塞应用启动
let pwaUtils = null
const loadPWAUtils = async () => {
  if (pwaUtils) return pwaUtils
  try {
    pwaUtils = await import('@/utils/pwa')
    // console.log('🔧 PWA工具模块加载成功')
    return pwaUtils
  } catch (error) {
    console.error('❌ PWA工具模块加载失败:', error)
    // 返回一个空对象，避免后续调用出错
    pwaUtils = {
      registerServiceWorker: () => Promise.resolve(() => {}),
      isPWASupported: () => false,
      isPWAInstalled: () => false,
      isOnline: () => true,
      checkForUpdate: () => {}
    }
    return pwaUtils
  }
}

// console.log('🔧 [3] 开始创建Vue应用实例')
const app = createApp(App)
// console.log('🔧 [4] Vue应用实例创建完成')

// 显式设置主题和语言配置
// console.log('🔧 [5] 开始配置ElementPlus')
app.use(ElementPlus, {
  locale: zhCn, // 使用中文语言包，包含分页等组件文案
  theme: {
    primary: '#1890ff' // 与 SCSS 中设置的颜色一致
  },
  // 支持 large、default、small，如果没有特殊需求可以保持默认
  size: Cookies.get('size') || 'default'
})
// console.log('🔧 [6] ElementPlus配置完成')

// 全局方法挂载
// console.log('🔧 [7] 开始挂载全局方法')
app.config.globalProperties.useDict = useDict
app.config.globalProperties.fullUrl = fullUrl
app.config.globalProperties.download = download
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
// console.log('🔧 [8] 全局方法挂载完成')

// 全局组件挂载
// console.log('🔧 [9] 开始挂载全局组件')
app.component('DictTag', DictTag)
// 表格下方的分页
app.component('Pagination', Pagination)
app.component('TreeSelect', TreeSelect)
app.component('FileUpload', FileUpload)
app.component('ImageUpload', ImageUpload)
app.component('ImagePreview', ImagePreview)
// 搜索框隐藏按钮+表格刷新按钮
app.component('RightToolbar', RightToolbar)
app.component('Editor', Editor)
// console.log('🔧 [10] 全局组件挂载完成')

// console.log('🔧 [11] 开始注册路由、状态管理、插件等')
app.use(router)
// console.log('🔧 [12] 路由注册完成')
app.use(store)
// console.log('🔧 [13] 状态管理注册完成')
app.use(plugins)
// console.log('🔧 [14] 插件注册完成')
app.use(elementIcons)
// console.log('🔧 [15] Element图标注册完成')
app.component('svg-icon', SvgIcon)
// console.log('🔧 [16] SVG图标组件注册完成')

// console.log('🔧 [17] 开始注册指令')
directive(app)
// console.log('🔧 [18] 指令注册完成')

// 使用element-plus 并且设置全局的大小
// app.use(ElementPlus, {
//   locale: zhCn,
//   // 支持 large、default、small
//   size: Cookies.get('size') || 'default'
// })

// console.log('🔧 [19] 开始挂载应用到DOM')
try {
  app.mount('#app')
  // console.log('🔧 [20] 应用已成功挂载到DOM')
} catch (error) {
  console.error('❌ [错误] 应用挂载失败:', error)
  throw error
}

// 移除加载动画
// 等待应用挂载完成后，添加 loaded class 来隐藏 loader
// console.log('🔧 [21] 准备移除加载动画')
setTimeout(() => {
  try {
    if (document.body) {
      document.body.classList.add('loaded')
      // console.log('🔧 [22] 加载动画已移除')
    } else {
      // console.warn('⚠️ [警告] document.body 不存在，无法移除加载动画')
    }
  } catch (error) {
    console.error('❌ [错误] 移除加载动画失败:', error)
  }
}, 100)

// ==================== PWA相关初始化 ====================
// 使用动态导入和 try-catch 包裹，确保即使出错也不影响应用运行
// 延迟初始化PWA，不阻塞应用启动
setTimeout(async () => {
  try {
    // console.log('🔧 开始PWA初始化')
    
    // 动态加载PWA工具模块
    const utils = await loadPWAUtils()
    const { 
      registerServiceWorker, 
      isPWASupported, 
      isPWAInstalled,
      isOnline,
      checkForUpdate
    } = utils
    
    // 检查PWA支持
    if (isPWASupported()) {
      // console.log('✅ PWA功能已支持')
      
      // 检查是否已安装
      if (isPWAInstalled()) {
        // console.log('📱 应用已安装为PWA')
      }
      
      // 注册Service Worker（仅在生产环境）
      if (import.meta.env.PROD) {
        // console.log('🔧 生产环境，开始注册Service Worker')
        // 使用异步方式注册，不阻塞应用启动
        registerServiceWorker()
          .then((updateSW) => {
            // 将更新函数挂载到全局，方便手动触发更新
            if (updateSW && typeof updateSW === 'function') {
              window.updatePWA = updateSW
            }
            
            // 定期检查更新（每小时检查一次）
            setInterval(() => {
              checkForUpdate()
            }, 60 * 60 * 1000)
            
            // console.log('✅ Service Worker注册完成')
          })
          .catch((error) => {
            console.error('❌ Service Worker注册失败:', error)
          })
      } else {
        // console.log('ℹ️ 开发环境，Service Worker已禁用')
      }
      
      // 网络状态监听
      const handleOnline = () => {
        // console.log('🌐 网络已连接')
        // 可以在这里触发网络恢复后的操作，比如同步数据
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('network-online'))
        }
      }
      
      const handleOffline = () => {
        // console.log('📴 网络已断开，应用将使用离线缓存')
        // 可以在这里显示离线提示
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('network-offline'))
        }
      }
      
      window.addEventListener('online', handleOnline)
      window.addEventListener('offline', handleOffline)
      
      // 初始网络状态
      if (!isOnline()) {
        handleOffline()
      }
      
      // 监听Service Worker更新事件
      window.addEventListener('sw-update-available', () => {
        // console.log('🔄 检测到Service Worker更新')
      })
      
      window.addEventListener('sw-offline-ready', () => {
        // console.log('✅ 应用已准备好离线使用')
      })
    } else {
      // console.warn('⚠️ 当前浏览器不支持PWA功能')
    }
    
    // console.log('🔧 PWA初始化完成')
  } catch (error) {
    console.error('❌ PWA初始化出错:', error)
    // 即使PWA初始化失败，也不影响应用运行
  }
}, 0)

// console.log('🔧 [23] 开始注册全局错误处理')

// ==================== 全局错误处理 ====================
// 捕获未处理的Promise错误
window.addEventListener('unhandledrejection', (event) => {
  // console.error('❌ [未处理的Promise错误]:', event.reason)
  // console.error('错误堆栈:', event.reason?.stack)
  // 可以在这里添加错误上报逻辑
})

// 捕获全局JavaScript错误
window.addEventListener('error', (event) => {
  const errorInfo = event.error || event.message || '未知错误'
  // console.error('❌ [全局JavaScript错误]:', errorInfo)
  // console.error('错误详情:', event)
  // 可以在这里添加错误上报逻辑
})

// console.log('🔧 [24] 全局错误处理注册完成')

// ==================== 性能监控（可选） ====================
if (import.meta.env.PROD && 'performance' in window) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      const perfData = performance.getEntriesByType('navigation')[0]
      if (perfData) {
        // console.log('📊 页面加载性能:', {
        //   'DNS查询': `${Math.round(perfData.domainLookupEnd - perfData.domainLookupStart)}ms`,
        //   'TCP连接': `${Math.round(perfData.connectEnd - perfData.connectStart)}ms`,
        //   '请求响应': `${Math.round(perfData.responseEnd - perfData.requestStart)}ms`,
        //   'DOM解析': `${Math.round(perfData.domContentLoadedEventEnd - perfData.domContentLoadedEventStart)}ms`,
        //   '页面加载': `${Math.round(perfData.loadEventEnd - perfData.fetchStart)}ms`
        // })
      }
    }, 0)
  })
}

// console.log('🚀 [25] 应用初始化完成 - main.js 执行完毕')
